import React, { useMemo, useEffect, useState } from "react";
import MusicIcon from "../../../assets/images/admin/music.svg";
import ReactSlider from 'react-slider';
import AsyncSelect from 'react-select/async';
import { useSelector, useDispatch } from "react-redux";
import debounce from "lodash.debounce";
import * as actions from '../../../redux/actions/growthEngine';
import { toast } from "react-toastify";
// react-select custom styles
const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: 'var(--primary)',
        border: '0',
        borderRadius: '0',
        color: '#fff',
        fontSize: '14px!important',
        padding: '0',
        margin: '0', outline: 'none', // Remove the outline on focus
        borderColor: state.isFocused ? 'transparent' : 'transparent', // Optionally remove the border color on focus
        boxShadow: state.isFocused ? 'none' : 'none', // Optionally remove any box-shadow
    }),
    input: (provided) => ({
        ...provided,
        color: '#fff', // Custom text color for input
        fontSize: '14px',
        padding: '0',
        margin: '0',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#fff', // Custom placeholder color
        fontSize: '14px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? '#ff6347' : provided.backgroundColor, // Focused option background
        color: state.isFocused ? 'white' : 'black', // Text color when option is focused
        fontSize: '14px',
    }),
};

export const StepFour = () => {
    const dispatch = useDispatch();
    const { formData } = useSelector(state => state.growthEngine);
    const { adAccountId, targeting } = formData;
    const isMetaConnected = Boolean(formData.metaLoggedIn || formData.facebookUserId);
    const isYoutubeAdsPath = formData.platformType === 'YouTube' && formData.objective === "YouTube Growth";
    const [searchSuggestions, setSearchSuggestions] = useState([]);

    const primaryMusicCountry = [
        { id: "US", "name": "United States" },
        { id: "JP", "name": "Japan" },
        { id: "GB", "name": "United Kingdom" },
        { id: "DE", "name": "Germany" },
        { id: "FR", "name": "France" },
        { id: "CA", "name": "Canada" },
        { id: "AU", "name": "Australia" },
        { id: "NL", "name": "Netherlands" }
    ]

    useEffect(() => {
        if (
            !isYoutubeAdsPath &&
            isMetaConnected &&
            (!formData.suggestedIntrests ||
                formData.suggestedIntrests.length === 0)
        ) {
            dispatch(
                actions.getSuggestedIntrest({
                    interest_list: "",
                })
            );
        }
    }, [dispatch, isMetaConnected, isYoutubeAdsPath, formData.objective]);

    // toasting wrning function
    const toastWarn = (msg) => {
        toast.warn(msg, {
            position: "top-center",
            theme: "colored",
            closeOnClick: true,
            autoClose: 2000,
            hideProgressBar: true,
        });
    };

    //  handle gender functionality
    const handleGenderChange = (selectedGender) => {
        if (formData.platformType === 'YouTube' && formData.objective === "YouTube Growth") {
            dispatch(actions.updateFormData({
                youtubeGender: selectedGender
            }));
        } else {
            dispatch(actions.updateFormData({
                targeting: {
                    ...formData.targeting,
                    gender: selectedGender
                }
            }));
        }
    };
    //   handle age functionality
    const handleAgeChange = (newValue) => {
        if (!Array.isArray(newValue) || newValue.length !== 2) return;
        let [min, max] = newValue;
        if (formData.platformType === 'YouTube' && formData.objective === "YouTube Growth") {
            dispatch(actions.updateFormData({
                youtubeAgeRange: { min, max }
            }));
        } else {
            if (formData.selectedLocationOption === "global" && min < 21) {
                min = 21
            } else if (min < 21 && formData.selectedLocationOption === "custom" && formData.targeting.location.locationEnum == 'custom') {
                const isSensitiveCountry = [
                    ...(formData.targeting.location.countries || []),
                    ...(formData.targeting.location.cities || []),
                    ...(formData.targeting.location.regions || [])
                ].some(loc => {
                    const name = loc.labelString?.toLowerCase?.() || '';
                    return name.includes('indonesia') || name.includes('thailand');
                });

                if (isSensitiveCountry) min = 21;
                if (isSensitiveCountry) {
                    toastWarn('Minimum age should not less then 21 for Indonesia and Thailand')
                }
            }
            dispatch(actions.updateFormData({
                targeting: {
                    ...formData.targeting,
                    ageRange: { min, max }
                }
            }));
        }
    };
    //   start location functionality
    const handleSelection = (option) => {
        // Calculate new min age if needed
        const newMinAge = (option === "global" && formData.targeting.ageRange.min < 21)
            ? 21
            : formData.targeting.ageRange.min;

        dispatch(actions.updateFormData({
            ...formData,
            selectedLocationOption: option,
            targeting: {
                ...formData.targeting,
                ageRange: {
                    min: newMinAge,
                    max: formData.targeting.ageRange.max
                },
                location:
                    option === "global"
                        ? { countries: [], regions: [], cities: [], locationEnum: "global" }
                        : option === "primary"
                            ? {
                                countries: primaryMusicCountry.map(country => ({
                                    id: country.id, name: country.name
                                })),
                                regions: [],
                                cities: [],
                                locationEnum: "primary"
                            }
                            : formData.targeting.location
            }
        }));
    };
    const fetchLocations = debounce((inputValue, callback) => {
        if (inputValue.length > 2) {
            dispatch(actions.getTargetLocation({ query: inputValue }))
                .then((response) => {
                    if (response.length > 0) {
                        callback(response.map(item => ({
                            label: (
                                <div>
                                    <div>{formatLocationLabel(item)}</div>
                                    <div className="text-xs text-white-400">{item.type}</div>
                                </div>
                            ),
                            value: item.key, // Unique ID
                            name: item.name, // Only store name
                            type: item.type, // Type (city, region, country)
                            country_code: item.country_code,
                            region_id: item.region_id,
                            labelString: formatLocationLabel(item),
                        })));
                    } else {
                        callback([]);
                    }
                })
                .catch(() => callback([]));
        } else {
            callback([]);
        }
    }, 500);

    const formatLocationLabel = (location) => {
        if (location.type === "city") {
            return `${location.name}, ${location.region}, ${location.country_name}`;
        } else if (location.type === "region") {
            return `${location.name}, ${location.country_name}`;
        } else if (location.type === "country") {
            return `${location.name}`;
        }
        return location.name;  // Default fallback
    };

    const handleLocationChange = (selectedOptions) => {
        const updatedTargeting = {
            ...formData.targeting,
            location: {
                cities: [...formData.targeting.location.cities],
                regions: [...formData.targeting.location.regions],
                countries: [...formData.targeting.location.countries],
                locationEnum: 'custom'
            }
        };
        const formattedLocation = {
            id: selectedOptions.value,
            name: selectedOptions.name,
            country_code: selectedOptions.country_code,
            region_id: selectedOptions.region_id || null,
            labelString: selectedOptions.labelString
        };
        const typeToKeyMap = {
            country: 'countries',
            region: 'regions',
            city: 'cities'
        };
        const key = typeToKeyMap[selectedOptions.type];
        const isAlreadySelected = updatedTargeting.location[key].some(loc => loc.id === formattedLocation.id);

        if (isAlreadySelected) {
            toastWarn(`${selectedOptions.type.charAt(0).toUpperCase() + selectedOptions.type.slice(1)} "${formattedLocation.name}" is already selected.`);
            return;
        }
        // Country Selection Conflict
        if (selectedOptions.type === 'country') {
            const isAlreadySelected = updatedTargeting.location.countries.some(country => country.id === formattedLocation.id);
            const hasCities = updatedTargeting.location.cities.some(city => city.country_code === formattedLocation.country_code);
            const hasRegions = updatedTargeting.location.regions.some(region => region.country_code === formattedLocation.country_code);
            if (isAlreadySelected) {
                toastWarn(`Country "${formattedLocation.name}" is already selected.`);
                return;
            }
            if (hasCities || hasRegions) {
                toastWarn(`Cannot select country "${formattedLocation.name}" because cities or regions from it are already selected.`);
                return;
            }

            updatedTargeting.location.countries.push(formattedLocation);
        }

        // Region Selection Conflict
        else if (selectedOptions.type === 'region') {
            const hasCountry = updatedTargeting.location.countries.some(country => country.id === formattedLocation.country_code);
            const overlappingCity = updatedTargeting.location.cities.find(city => String(city.region_id) === selectedOptions.value);
            if (hasCountry) {
                toastWarn(`Cannot select region "${formattedLocation.name}" because its country is already selected.`);
                return;
            }

            if (overlappingCity) {
                toastWarn(`Cannot select region "${formattedLocation.name}" because city "${overlappingCity.name}" inside it is already selected.`);
                return;
            }

            updatedTargeting.location.regions.push(formattedLocation);
        }

        // City Selection Conflict
        else if (selectedOptions.type === 'city') {
            const hasCountry = updatedTargeting.location.countries.some(country => country.id === formattedLocation.country_code);
            const overlappingRegion = updatedTargeting.location.regions.find(region => String(region.id) === String(formattedLocation.region_id));
            // const sameRegionCityExists = updatedTargeting.location.cities.some(city => String(city.region_id) === String(formattedLocation.region_id));
            if (hasCountry) {
                toastWarn(`Cannot select city "${formattedLocation.name}" because its country is already selected.`);
                return;
            }

            if (overlappingRegion) {
                toastWarn(`Cannot select city "${formattedLocation.name}" because its region "${overlappingRegion.name}" is already selected.`);
                return;
            }
            // if (sameRegionCityExists) {
            //     toastWarn(`Cannot select city "${formattedLocation.name}" because another city from the same region is already selected.`);
            //     return;
            // }

            updatedTargeting.location.cities.push(formattedLocation);
        }

        const labelString = selectedOptions.labelString?.toLowerCase() || '';
        const isSensitiveCountry =
            labelString.includes('indonesia') || labelString.includes('thailand');

        if (isSensitiveCountry && formData.targeting.ageRange.min < 21) {
            dispatch(
                actions.updateFormData({
                    ...formData,
                    targeting: {
                        ...updatedTargeting,
                        ageRange: {
                            ...formData.targeting.ageRange,
                            min: 21,
                            max: formData.targeting.ageRange.max
                        }
                    }
                })
            );
        } else {
            dispatch(
                actions.updateFormData({
                    ...formData,
                    targeting: updatedTargeting
                })
            );
        }
    };
    const SelectedLocationTag = ({ location, type }) => {
        return (
            <div className="bg-gradient-to-b from-[#FA6138] to-[#FF3D00] text-white text-[13px] font-roboto flex items-center gap-2 capitalize rounded-lg leading-tight pl-4 p-[8px]">
                {/* Show name and type */}
                {location.name} ({type})

                {/* Remove location */}
                <i
                    className="bi bi-x text-base leading-none cursor-pointer"
                    onClick={() => removeLocation(location.id, type)}
                ></i>
            </div>
        );
    };
    const removeLocation = (id, type) => {
        // Create a deep copy of formData.targeting.location
        const updatedTargeting = {
            ...formData.targeting,
            location: {
                cities: [...formData.targeting.location.cities],
                regions: [...formData.targeting.location.regions],
                countries: [...formData.targeting.location.countries],
                locationEnum: formData.targeting.location.locationEnum
            },
        };

        // Remove the selected location based on type
        if (type === "city") {
            updatedTargeting.location.cities = updatedTargeting.location.cities.filter((l) => l.id !== id);
        } else if (type === "region") {
            updatedTargeting.location.regions = updatedTargeting.location.regions.filter((l) => l.id !== id);
        } else if (type === "country") {
            updatedTargeting.location.countries = updatedTargeting.location.countries.filter((l) => l.id !== id);
        }

        // Dispatch the updated state
        dispatch(actions.updateFormData({
            ...formData,
            targeting: updatedTargeting
        }));
    };
    //   End location functionality
    //   start Language functionality
    const fetchLanguages = debounce((inputValue, callback) => {
        if (inputValue.length > 2) {
            //         getTargetlanguage,
            // getTargetIntrest
            dispatch(actions.getTargetlanguage({ query: inputValue }))
                .then((response) => {
                    if (response.length > 0) {
                        callback(response.map(item => ({
                            label: item.name,
                            value: item.key, // Unique ID
                            name: item.name, // Only store name
                        })));
                    } else {
                        callback([]);
                    }
                })
                .catch(() => callback([]));
        } else {
            callback([]);
        }
    }, 500);

    const handleLanguageChange = (selectedOptions) => {
        if (!selectedOptions) return;
        const selectedLanguage = {
            id: selectedOptions.value,
            name: selectedOptions.label
        };
        const alreadySelected = formData.targeting.languages.some(
            language => language.id === selectedLanguage.id
        );

        if (alreadySelected) {
            toastWarn(`Language "${selectedLanguage.name}" is already selected.`);
            return;
        }
        const updatedTargeting = {
            ...formData.targeting,
            languages: [...formData.targeting.languages, selectedLanguage]
        };
        dispatch(actions.updateFormData({ ...formData, targeting: updatedTargeting }));
    };
    //   End Language functionality

    //   start interest functionality
    const fetchInterestSearch = debounce((inputValue, callback) => {
        if (inputValue.length > 2) {
            dispatch(actions.getTargetIntrest({ query: inputValue }))
                .then((response) => {
                    setSearchSuggestions(response || []);
                    if (response.length > 0) {
                        callback(response.map(item => ({
                            label: item.name,
                            value: item.id, // Unique ID
                            name: item.name, // Only store name
                        })));
                    } else {
                        callback([]);
                    }
                })
                .catch(() => callback([]));
        } else {
            callback([]);
        }
    }, 500);

    const handleInterestChange = (selectedOptions) => {
        if (!selectedOptions) return;

        const selectedInterests = {
            id: selectedOptions.value,
            name: selectedOptions.label
        };

        const alreadySelected = formData.targeting.interests.some(
            interest => interest.id === selectedInterests.id
        );

        if (alreadySelected) {
            toastWarn(`Interest "${selectedInterests.name}" is already selected.`);
            return;
        }

        const updatedTargeting = {
            ...formData.targeting,
            interests: [...formData.targeting.interests, selectedInterests]
        };

        dispatch(actions.updateFormData({ ...formData, targeting: updatedTargeting }));

        // dispatch(actions.getSuggestedIntrest({
        //     access_token: formData.metaAccessToken,
        //     interest_list: selectedOptions.label
        // }, toast));
    };
    //   End interest functionality

    const handleSelectSuggestIntrest = (selectedOptions) => {
        if (!selectedOptions) return;

        const selectedInterests = {
            id: selectedOptions.id,
            name: selectedOptions.name
        };

        const alreadySelected = formData.targeting.interests.some(
            interest => interest.id === selectedInterests.id
        );

        if (alreadySelected) {
            toastWarn(`Interest "${selectedInterests.name}" is already selected.`);
            return;
        }

        const updatedTargeting = {
            ...formData.targeting,
            interests: [...formData.targeting.interests, selectedInterests]
        };

        dispatch(actions.updateFormData({ ...formData, targeting: updatedTargeting }));
    };

    const formatTargetingSpec = (targeting) => {
        let geoLocations = {};

        if (targeting.location.countries.length) {
            geoLocations.countries = targeting.location.countries.map(country => country.id);
        } else if (targeting.location.regions.length) {
            geoLocations.regions = targeting.location.regions.map(region => ({ key: region.id }));
        } else if (targeting.location.cities.length) {
            geoLocations.cities = targeting.location.cities.map(city => ({ key: city.id }));
        } else {
            // If no location is selected, apply a global reach to a set of countries
            geoLocations.countries = ["US", "GB", "CA", "AU", "DE", "FR", "IN", "BR", "JP", "CN",
                "MX", "IT", "ES", "NL", "SE", "NO", "SG", "ZA", "KR", "AR"];
        }

        return {
            age_min: targeting.ageRange.min,
            age_max: targeting.ageRange.max,
            geo_locations: geoLocations,
            genders: targeting.gender === 'All' ? [1, 2] : targeting.gender === 'Male' ? [1] : [2],
            interests: targeting.interests.map(interest => ({ id: interest.id })),
            behaviors: targeting.behaviors.map(behavior => ({ id: behavior.id })),
            locales: targeting.languages.map(language => language.id),
            publisher_platforms: ["facebook", "instagram"],
            device_platforms: targeting.deviceTypes.length ? targeting.deviceTypes : ["mobile", "desktop"]
        };
    };

    const data = useMemo(() => ({
        ad_account_id: adAccountId,
        targeting: formatTargetingSpec(targeting)
    }), [adAccountId, targeting]);

    useEffect(() => {
        if (!isYoutubeAdsPath) {
            dispatch(actions.getPotentialReach(data, toast));
        }

    }, [dispatch, data, isYoutubeAdsPath]);

    //   start Youtube Language functionality
    const fetchYoutubeLanguages = debounce((inputValue, callback) => {
        if (inputValue.length > 2) {
            dispatch(actions.getYoutubeTargetLanguage(inputValue, toast))
                .then((response) => {
                    if (response.length > 0) {
                        callback(response.map(item => ({
                            label: item.name,
                            value: item.id, // Unique ID
                            code: item.code,
                            resourceName: item.resourceName,
                            name: item.name, // Only store name
                        })));
                    } else {
                        callback([]);
                    }
                })
                .catch(() => callback([]));
        } else {
            callback([]);
        }
    }, 500);

    const handleYoutubeLanguageChange = (selectedOptions) => {
        const selectedLanguage = {
            id: selectedOptions.value, name: selectedOptions.name,
            resourceName: selectedOptions.resourceName, code: selectedOptions.code
        };
        // Ensure previous languages are retained and add the new selection
        const updatedLanguages = [...formData.youtubeTargetLanguage, selectedLanguage];
        dispatch(actions.updateFormData({ youtubeTargetLanguage: updatedLanguages }));
    };
    //   End  youtube Language functionality

    return (
        <div className="font-inter text-theme_clr1 mb-[61px]" data-tour="audience-targeting">
            <div className="heading text-white font-medium text-center mb-[28.5px]">
                <h5 className="text-[22.5px] mb-1">Audience targeting</h5>
                <div className="description text-white text-opacity-80 text-[15px]">Choose who you want your ad campaign to be shown to</div>
            </div>
            <div className="info-box bg-white rounded-xl p-4 lg:p-5">
                <div className="flex flex-col lg:flex-row gap-4 xl:gap-5" data-tour="demographic-targeting">
                    <div className="left-info lg:w-[50%]">
                        <div className="title-name text-[22.69px] font-medium mb-2">Demographic targeting</div>
                        <div className="description font-medium text-theme_clr1 text-[15px] leading-tight">
                            Choose the target demographics for your ad campaign.
                        </div>
                    </div>
                    <div className="right-info lg:w-[50%]">
                        <div className="bg-white border-2 border-theme_clr1 rounded-2xl mb-2 p-4">
                            <div className="title text-[15.25px] font-medium mb-4">Gender</div>
                            <div className="radio-wrapper flex gap-1">
                                {["All", "Male", "Female"].map((gender) => (
                                    <div key={gender} className="input-cover w-full">
                                        <input
                                            type="radio"
                                            className="peer hidden"
                                            name="genderStatus"
                                            id={gender}
                                            // checked={formData?.targeting?.gender === gender}
                                            checked={
                                                (formData.platformType === 'YouTube' && formData.objective === "YouTube Growth")
                                                    ? formData?.youtubeGender === gender
                                                    : formData?.targeting?.gender === gender
                                            }
                                            onChange={() => handleGenderChange(gender)}
                                        />
                                        <label
                                            className="text-white text-sm font-medium min-h-[40px] flex items-center justify-center gap-1 bg-theme_clr1 peer-checked:bg-theme_clr2 rounded-xl px-4 py-2"
                                            htmlFor={gender}
                                        >
                                            {gender === "Male" ? (
                                                <i className="bi bi-gender-male leading-none"></i>
                                            ) : gender === "Female" ? (
                                                <i className="bi bi-gender-female leading-none"></i>
                                            ) : (
                                                <i className="bi bi-gender-female leading-none -rotate-180"></i>
                                            )}
                                            {gender}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="bg-white border-2 border-theme_clr1 rounded-2xl p-4">
                            <div className="title text-[15.25px] font-medium mb-4">Age range</div>
                            <div className="rangle-slider-wrapper mb-5">
                                <ReactSlider min={formData.platformType !== 'YouTube' && formData.selectedLocationOption === "global" ? 21 : 18} max={65} step={1}
                                    value={
                                        (formData.platformType === 'YouTube' && formData.objective === "YouTube Growth")
                                            ? [formData?.youtubeAgeRange?.min ?? 18, formData?.youtubeAgeRange?.max ?? 65]
                                            : [formData?.targeting?.ageRange?.min ?? 18, formData?.targeting?.ageRange?.max ?? 65]
                                    }
                                    onChange={handleAgeChange}
                                    renderThumb={(props, state) => {
                                        const { key, ...restProps } = props;
                                        return (
                                            <div
                                                key={key}
                                                {...restProps}
                                                className="range-slider-thumb h-4 w-4 bg-white border-[2px] border-theme_clr2 rounded-full focus:outline-none"
                                            ></div>
                                        );
                                    }}
                                    renderTrack={(props) => {
                                        const { key, ...restProps } = props;
                                        return <div key={key} {...restProps} className="range-slider-track h-[15px] bg-[#ffb9aa] rounded-full" />;
                                    }}
                                    className="range-slider h-[15px] flex items-center"
                                    minDistance={1}
                                />
                                <div className="text-xs font-semibold flex justify-between gap-2 mt-1">
                                    <span>{formData.platformType === 'YouTube' && formData.objective === "YouTube Growth"
                                        ? formData?.youtubeAgeRange?.min
                                        : formData?.targeting?.ageRange?.min}</span>

                                    <span>{formData.platformType === 'YouTube' && formData.objective === "YouTube Growth"
                                        ? formData?.youtubeAgeRange?.max
                                        : formData?.targeting?.ageRange?.max}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {
                    !isYoutubeAdsPath ?
                        <>
                            <hr className="border-black my-4" />
                            <div className="flex flex-col lg:flex-row gap-4 xl:gap-5" data-tour="location-targeting">
                                <div className="left-info lg:w-[50%]">
                                    <div className="title-name text-[22.69px] font-medium mb-2">Location targeting</div>
                                    <div className="description font-medium text-theme_clr1 text-[15px] leading-tight mb-4">
                                        Choose the target locations for your ad campaign.
                                    </div>
                                    <div className="location-info-wrapper">
                                        <div className="text-base font-bold text-theme_clr4 mb-2">
                                            <i className="bi bi-exclamation-triangle-fill"></i> Location Verification Notice
                                        </div>
                                        <div className="description text-[13px] text-gray-700 mb-3">
                                            <p className="mb-3">
                                                Due to local regulations, running ads in <span className="font-medium text-theme_clr1">Singapore</span> and <span className="font-medium text-theme_clr1">Taiwan</span> may require additional verification in Meta Ads Manager.
                                            </p>
                                            <ul className="list-disc ps-4 mb-3">
                                                <li className="mb-1">
                                                    <span className="font-medium text-theme_clr1">Singapore →</span> You may need to declare a verified payer & beneficiary (advertiser identity).
                                                </li>
                                                <li>
                                                    <span className="font-medium text-theme_clr1">Taiwan →</span> Meta may require full business verification before campaigns can run.
                                                </li>
                                            </ul>
                                            <p>
                                                <span className="font-medium text-theme_clr1">Suggested approach:</span> Verify your business in Meta Ads Manager → Business Info. If required, add beneficiary and payer details as defaults for your ads under the Verifications page to avoid delays.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="right-info lg:w-[50%]">
                                    {/* Primary Music Markets */}
                                    <div className={`border-2 ${formData.selectedLocationOption === "primary" ? "bg-theme_clr2 border-theme_clr2" : " bg-white border-theme_clr1"} rounded-2xl mb-4 p-4 cursor-pointer`} onClick={() => handleSelection("primary")}>
                                        <div className="flex gap-5">
                                            <div className="icon pt-1">
                                                <img src={MusicIcon} alt="MusicIcon" className="block w-[24px]" />
                                            </div>
                                            <div className="info">
                                                <div className="text-[15.25px] font-medium capitalize leading-tight">Primary Music Markets</div>
                                                <div className="subtitle text-sm uppercase">(USA, JPN, UK, GER, FRA, CAN, AUS, NLD)</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Global */}
                                    <div className={`border-2 ${formData.selectedLocationOption === "global" ? "bg-theme_clr2 border-theme_clr2" : "bg-white border-theme_clr1"} rounded-2xl mb-4 p-4 cursor-pointer`} onClick={() => handleSelection("global")}>
                                        <div className="flex items-center gap-5">
                                            <i className="bi bi-globe-americas text-xl leading-none"></i>
                                            <div className="text-[15.25px] font-medium capitalize leading-tight">Global</div>
                                        </div>
                                    </div>

                                    {/* Custom Location */}
                                    <div className={`bg-white border-2 ${formData.selectedLocationOption === "custom" ? "border-theme_clr2" : "border-theme_clr1"} rounded-2xl p-4`}>
                                        <div className="flex items-center gap-5 mb-2 cursor-pointer" onClick={() => dispatch(actions.updateFormData({ ...formData, selectedLocationOption: "custom" }))}>
                                            <i className="bi bi-geo-alt-fill text-xl leading-none"></i>
                                            <div className="text-[15.25px] font-medium capitalize leading-tight">Select custom location</div>
                                        </div>
                                        <div className="text-xs font-medium mb-4">Choose specific target locations for your ad campaign</div>
                                        <div className="search-wrapper">
                                            <div className="search-box bg-theme_clr1 rounded-full px-4 py-1 flex items-center relative">
                                                <i className="bi bi-search text-white"></i>
                                                <AsyncSelect
                                                    className="custom-select w-full text-white"
                                                    styles={customStyles}
                                                    loadOptions={fetchLocations} // Fetch options asynchronously
                                                    defaultOptions // Show initial options
                                                    placeholder="Search location"
                                                    cacheOptions
                                                    noOptionsMessage={() => "No results found"} // Show message if no options
                                                    onFocus={() => dispatch(actions.updateFormData({ selectedLocationOption: "custom" }))}
                                                    onChange={handleLocationChange} // Handle selection
                                                    controlShouldRenderValue={false}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                        SingleValue: ({ data }) => (
                                                            <div>
                                                                <div>{data.labelString}</div>
                                                                <div className="text-xs text-white-400">{data.type}</div>
                                                            </div>
                                                        ),
                                                    }}
                                                />
                                            </div>
                                            {formData.targeting.location && formData.selectedLocationOption === "custom" &&
                                                (formData.targeting.location.cities.length > 0 ||
                                                    formData.targeting.location.regions.length > 0 ||
                                                    formData.targeting.location.countries.length > 0) && (
                                                    <div className="search-suggestion flex flex-wrap gap-2 mt-4">
                                                        {/* Render cities */}
                                                        {formData.targeting.location.cities.map((location) => (
                                                            <SelectedLocationTag key={location.id} location={location} type="city" />
                                                        ))}
                                                        {/* Render regions */}
                                                        {formData.targeting.location.regions.map((location) => (
                                                            <SelectedLocationTag key={location.id} location={location} type="region" />
                                                        ))}
                                                        {/* Render countries */}
                                                        {formData.targeting.location.countries.map((location) => (
                                                            <SelectedLocationTag key={location.id} location={location} type="country" />
                                                        ))}
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        : ''
                }


                <hr className="border-black my-4" />
                {
                    isYoutubeAdsPath ?
                        // youtube lang seraching
                        <div className="flex flex-col lg:flex-row gap-4 xl:gap-5" data-tour="language-targeting">
                            <div className="left-info lg:w-[50%]">
                                <div className="title-name text-[22.69px] font-medium mb-2">Language targeting</div>
                                <div className="description font-medium text-theme_clr1 text-[15px] leading-tight">
                                    Choose the target language for your ad campaign.
                                </div>
                            </div>
                            <div className="right-info lg:w-[50%]">
                                {/* Language*/}
                                <div className={`bg-white border-2 border-theme_clr1 rounded-2xl p-4`}>
                                    <div className="flex items-center gap-5 mb-2 cursor-pointer">
                                        <i className="bi bi-translate text-xl leading-none"></i>
                                        <div className="text-[15.25px] font-medium capitalize leading-tight">Select language</div>
                                    </div>
                                    <div className="text-xs font-medium mb-4">Choose specific target language for your ad campaign</div>

                                    <div className="search-wrapper-language">
                                        <div className="search-box bg-theme_clr1 rounded-full px-4 py-1 flex items-center relative">
                                            <i className="bi bi-search text-white"></i>
                                            <AsyncSelect
                                                className="custom-select w-full text-white"
                                                styles={customStyles}
                                                loadOptions={fetchYoutubeLanguages} // Fetch options asynchronously
                                                defaultOptions // Show initial options
                                                placeholder="Search language"
                                                cacheOptions
                                                noOptionsMessage={() => "No results found"} // Show message if no options
                                                onChange={handleYoutubeLanguageChange} // Handle selection
                                                controlShouldRenderValue={false}
                                                components={{
                                                    DropdownIndicator: () => null,
                                                    IndicatorSeparator: () => null,
                                                    SingleValue: ({ data }) => (
                                                        <div>
                                                            <div>{data.label}</div>
                                                        </div>
                                                    ),
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* Selected Languages */}
                                {formData.youtubeTargetLanguage.length > 0 && (
                                    <div className="search-suggestion flex flex-wrap gap-2 mt-4">
                                        {formData.youtubeTargetLanguage.map((language, index) => (
                                            <div key={index} className="bg-gradient-to-b from-[#FA6138] to-[#FF3D00] text-white text-[13px] font-roboto flex items-center gap-2 capitalize rounded-lg leading-tight pl-4 p-[8px]">
                                                {language.name}
                                                <i className="bi bi-x text-base leading-none cursor-pointer"
                                                    onClick={() => {
                                                        const updatedLanguages = formData.youtubeTargetLanguage.filter(lang => lang.id !== language.id);
                                                        dispatch(actions.updateFormData({ youtubeTargetLanguage: updatedLanguages }));
                                                    }}>
                                                </i>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                        :
                        <div className="flex flex-col lg:flex-row gap-4 xl:gap-5" data-tour="language-targeting">
                            <div className="left-info lg:w-[50%]">
                                <div className="title-name text-[22.69px] font-medium mb-2">Language targeting</div>
                                <div className="description font-medium text-theme_clr1 text-[15px] leading-tight">
                                    Choose the target language for your ad campaign.
                                </div>
                            </div>
                            <div className="right-info lg:w-[50%]">
                                {/* Language*/}
                                <div className={`bg-white border-2 border-theme_clr1 rounded-2xl p-4`}>
                                    <div className="flex items-center gap-5 mb-2 cursor-pointer">
                                        <i className="bi bi-translate text-xl leading-none"></i>
                                        <div className="text-[15.25px] font-medium capitalize leading-tight">Select language</div>
                                    </div>
                                    <div className="text-xs font-medium mb-4">Choose specific target language for your ad campaign</div>

                                    <div className="search-wrapper-language">
                                        <div className="search-box bg-theme_clr1 rounded-full px-4 py-1 flex items-center relative">
                                            <i className="bi bi-search text-white"></i>

                                            <AsyncSelect
                                                className="custom-select w-full text-white"
                                                styles={customStyles}
                                                loadOptions={fetchLanguages} // Fetch options asynchronously
                                                defaultOptions // Show initial options
                                                placeholder="Search language"
                                                cacheOptions
                                                noOptionsMessage={() => "No results found"} // Show message if no options
                                                onChange={handleLanguageChange} // Handle selection
                                                controlShouldRenderValue={false}
                                                components={{
                                                    DropdownIndicator: () => null,
                                                    IndicatorSeparator: () => null,
                                                    SingleValue: ({ data }) => (
                                                        <div>
                                                            <div>{data.label}</div>
                                                        </div>
                                                    ),
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* Selected Languages */}
                                {formData.targeting.languages.length > 0 && (
                                    <div className="search-suggestion flex flex-wrap gap-2 mt-4">
                                        {formData.targeting.languages.map((language, index) => (
                                            <div key={index} className="bg-gradient-to-b from-[#FA6138] to-[#FF3D00] text-white text-[13px] font-roboto flex items-center gap-2 capitalize rounded-lg leading-tight pl-4 p-[8px]">
                                                {language.name}
                                                <i className="bi bi-x text-base leading-none cursor-pointer"
                                                    onClick={() => {
                                                        const updatedLanguages = formData.targeting.languages.filter(lang => lang.id !== language.id);
                                                        dispatch(actions.updateFormData({
                                                            ...formData,
                                                            targeting: { ...formData.targeting, languages: updatedLanguages }
                                                        }));
                                                    }}>
                                                </i>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                }

                {
                    !isYoutubeAdsPath ?
                        <>
                            <hr className="border-black my-4" />

                            <div className="flex flex-col lg:flex-row gap-4 xl:gap-5" data-tour="interest-targeting">
                                <div className="left-info lg:w-[50%]">
                                    <div className="title-name text-[22.69px] font-medium mb-2">Interest targeting</div>
                                    <div className="description font-medium text-theme_clr1 text-[15px] leading-tight">
                                        Your ad will be served to fans who are interested in the
                                        topics listed here. Only select relevant interests so
                                        targeting is as precise as possible.
                                    </div>
                                </div>
                                <div className="right-info lg:w-[50%]">
                                    <div className="bg-white border-2 border-theme_clr1 rounded-2xl p-4">
                                        <div className="search-box bg-theme_clr1 rounded-full px-4 py-2 flex items-center gap-2 relative mb-4">
                                            <i className="bi bi-search text-white"></i>
                                            <AsyncSelect
                                                className="custom-select w-full text-white"
                                                styles={customStyles}
                                                loadOptions={fetchInterestSearch} // Fetch options asynchronously
                                                defaultOptions // Show initial options
                                                placeholder="Search interest targets"
                                                cacheOptions
                                                noOptionsMessage={() => "No results found"} // Show message if no options
                                                onChange={handleInterestChange} // Handle selection
                                                controlShouldRenderValue={false}
                                                components={{
                                                    DropdownIndicator: () => null,
                                                    IndicatorSeparator: () => null,
                                                    SingleValue: ({ data }) => (
                                                        <div>
                                                            <div>{data}</div>
                                                        </div>
                                                    ),
                                                }}
                                            />
                                        </div>
                                        <div className="interest-suggestion mb-4">
                                            <div className="text-[15.25px] font-medium capitalize leading-tight">Selected interest targets</div>
                                            <div className="flex flex-wrap gap-2 mt-4">
                                                {/* Selected interests */}
                                                {formData.targeting.interests.length > 0 && (
                                                    <div className="search-suggestion flex flex-wrap gap-2 mt-4">
                                                        {formData.targeting.interests.map((interest, index) => (
                                                            <div key={interest.id} className="bg-gradient-to-b from-[#FA6138] to-[#FF3D00] text-white text-[13px] font-roboto flex items-center gap-2 capitalize rounded-lg leading-tight pl-4 p-[8px]">
                                                                {interest.name}
                                                                <i className="bi bi-x text-base leading-none cursor-pointer"
                                                                    onClick={() => {
                                                                        const updatedInterest = formData.targeting.interests.filter(ints => ints.id !== interest.id);
                                                                        // ints => ints.id !== interest.id
                                                                        dispatch(actions.updateFormData({
                                                                            ...formData,
                                                                            targeting: { ...formData.targeting, interests: updatedInterest }
                                                                        }));
                                                                    }}>
                                                                </i>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="interest-suggestion">
                                            <div className="text-[15.25px] font-medium capitalize leading-tight">More suggested interest targets</div>
                                            <div className="flex flex-wrap gap-2 mt-4">

                                                {formData.suggestedIntrests?.length > 0 && (
                                                    // <div className="search-suggestion flex flex-wrap gap-2 mt-4">
                                                    //     {formData.suggestedIntrests.map((interest, index) => (
                                                    //         <div key={interest.id} className="bg-white border border-theme_clr1 text-theme_clr1 text-[13px] font-roboto flex items-center gap-2 capitalize rounded-lg leading-tight pl-4 p-[8px]"
                                                    //             onClick={() => handleSelectSuggestIntrest(interest)}
                                                    //         >
                                                    //             {interest.name} <i className="bi bi-plus text-base leading-none cursor-pointer"></i>
                                                    //         </div>
                                                    //     ))}
                                                    // </div>
                                                    <div className="search-suggestion flex flex-wrap gap-2 mt-4">

                                                        {/* 🔥 DEFAULT SUGGESTIONS */}
                                                        {formData.suggestedIntrests?.map((interest) => (
                                                            <div
                                                                key={`default-${interest.id}`}
                                                                className="bg-white border border-theme_clr1 text-theme_clr1 text-[13px] flex items-center gap-2 rounded-lg pl-4 p-[8px]"
                                                                onClick={() => handleSelectSuggestIntrest(interest)}
                                                            >
                                                                {interest.name}
                                                                <i className="bi bi-plus"></i>
                                                            </div>
                                                        ))}

                                                        {/* SEARCH SUGGESTIONS */}
                                                        {searchSuggestions?.map((interest) => (
                                                            <div
                                                                key={`search-${interest.id}`}
                                                                className="bg-white border border-theme_clr1 text-theme_clr1 text-[13px] flex items-center gap-2 rounded-lg pl-4 p-[8px]"
                                                                onClick={() => handleSelectSuggestIntrest(interest)}
                                                            >
                                                                {interest.name}
                                                                <i className="bi bi-plus"></i>
                                                            </div>
                                                        ))}

                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        : ''
                }
            </div>
        </div>
    )
}


